import { castArray } from '../../views/utils'

const loadQueue = []
const postLoad = []
let loadingPromise = null

export default {
  store: {
    state: {
      isLoaded: true,
    },
    actions: {
      EXEC_POST_LOAD() {
        postLoad.forEach((task) => {
          if (task.done) return
          task.done = true
          task.fn()
        })
      },

      /*
        Sets state.isLoaded = true, after given loader Promise
        is resolved.
      */
      LOAD({ commit, dispatch, state }, loader) {
        if (!loader) return

        const loaderFunction = () => Promise
          .all(castArray(loader)
            .map(actionNameOrFn =>
              typeof actionNameOrFn === 'function'
                ? actionNameOrFn()
                : dispatch(actionNameOrFn)))

        loadQueue.push(loaderFunction)

        const executeNext = async () => {
          if (!loadQueue.length) {
            commit('SET_LOADED', true)
            dispatch('EXEC_POST_LOAD')
            return Promise.resolve()
          }

          const task = loadQueue.slice(0, 1)[0]
          await task()
          if (loadQueue.length) loadQueue.splice(0, 1)
          loadingPromise = executeNext()
        }

        if (!loadQueue.length) return Promise.resolve()

        if (state.isLoaded) {
          commit('SET_LOADED', false)
          return executeNext()
        }

        return loadingPromise
      },

      /*
        Triggers given function fn when page has been loaded.
      */
      POST_LOAD({ commit, state }, fn) {
        if (state.isLoaded) return fn()

        commit('ADD_TO_POSTLOAD', fn)
      },
    },

    mutations: {
      ADD_TO_POSTLOAD(_, fn) {
        postLoad.push({
          done: false,
          fn,
        })
      },
      SET_LOADED(state, value) {
        state.isLoaded = value
      },
    },

    getters: {
      isLoaded: state => state.isLoaded,
    },
  },
}
